export const vendorIdDict = {
  fedexnavitormcc: '250',
};

import { isMobileOnly } from 'react-device-detect';

export const Int32MaxValue = 2147483647;
export const QuantityOverflow = -1;

export const QuantityInputMaxLength = 8;
export const QuantityInputMaxLengthForThirdPartyBrands = 5;
export const SingleQuantityInputMaxValue = 99999999;
export const SingleQuantityInputMaxValueForThirdPartyBrands = 99999;
export const MaximumQuantityForThirdPartyBrands = 99999;

export const NumericValueOfNotAvailable = -1;
export const StringValueOfNotAvailable = 'N/A';

export const MAX_UPLOAD_FILE_SIZE = 30 * 1024 * 1024;
export const CANVAS_BORDER_WIDTH = 1;
export const CANVAS_BORDER_WIDTH_BOLD = 2;
export const MOBILE_CANVAS_BORDER_WIDTH = 2;
export const MOBILE_CANVAS_BORDER_WIDTH_VIGNETTE = 2;
export const CANVAS_MAX_TEXT = 50;
export const CANVAS_MAX_SNAP_LINES = 25;
export const API_UPLOAD_LOGO = '/api/v1/uploadlogo';
export const API_EDIT_LOGO = '/api/v1/editlogo';
export const API_PROGRESS = '/api/v1/progress';
export const API_COLORIZE = '/api/v1/colorize';

export const IMPRINT_AREA_NONE = 'NA-NA-NA';
export const DASH = '-';
export const UNDERSCORE = '_';
export const WEBUSER_CS_GUEST = 'Guest';
export const IMAGE_CROP_GRIP_SIZE = 11;
export const IMAGE_CROP_MIN_SIZE = 40;
export const PERCENT_OF_FILE_UPLOADED = 20;
export const TOKEN_EXPIRATION_CAPTION =
  'Your session has expired due to inactivity. Pressing "Ok" will go back to the previous page.';
export const MESSAGE_ELEMENT_NOT_FIT =
  'Your text is too long to fit properly within the imprint area.  Please review it.';
export const ART_NOT_AVAILABLE = 'Currently the art is not available. Please select another one.';
export const SINGLE_COLOR_WARNING = 'Your logo will be imprinted in a single color. We recommend uploading a new logo.';
export const ITEM_CANNOT_CUSTOMIZED = 'This item cannot be customized at this time.';
export const CANVAS_IMPRINT_TOO_CLOSE =
  'Your text and/or logo elements are too close together to print properly. Please separate your elements by moving them or reducing their size.';
export const NOTE_VIRTUAL_PROOF = 'NOTE: All proofs are branded with ADG Promo information.';

export const REDUCE_CANVAS_CONTAINER_SIZE = 0.3;
export const MAX_SIDE_BAR_WIDTH = 385;
export const MIN_SIDE_BAR_WIDTH = 345;
export const SIDE_BAR_TAB_WIDTH = 80;
export const PREVIEW_WIDTH = 180; //.configurator-web-update-preview-btn:width
export const CANVAS_MARGIN = 10; //=.canvas-area:margin
export const CANVAS_TOOLBAR_CONTENT_WIDTH = 180 * 3; // 3 canvas top toolbar buttons
export const MAX_CANVAS_SIZE = 1200;
export const MIN_CANVAS_SIZE = 600;
export const MAX_CANVAS_SCALE = 8;
export const SIDEBAR_IMAGE_WIDTH_PERCENT = 0.8;
export const MAX_UPLOAD_LOGO_SIZE = 2000;
export const DEFAULT_CANVAS_SIZE = 600;
export const ART_INIT_SIZE_PERCENT = 0.8;
export const MIN_ART_INIT_SIZE = 60;
export const MOBILE_CANVAS_MARGIN = 10;
export const MOBILE_CROP_PANEL_HEIGHT = 200;
export const MOBILE_HEADER_HEIGHT = 65;
export const MOBILE_PROCESS_BAR_HEIGHT = 64;
export const MOBILE_CROP_EXTRA_MARGIN_Y = 25;
export const MOBILE_CROP_EXTRA_MARGIN_X = 10;
export const MOBILE_RULERTEXT_EVEN_NUMBER_DISPLAY = 28; //=MAX_RULERTEXT_LENGTH+4:Improve Ruler Display When Page Too Narrow
export const CANVAS_STANDARD_TAB_DESCRIPTION = 'Standard';
export const CANVAS_GRID_EXTEND = 5;
export const MAX_RULERLINE_LENGTH = 20;
export const MAX_RULERTEXT_LENGTH = 24;
export const RULER_LEFT_MARGIN = 5;
export const IMAGE_ELEMENT_INIT_ZINDEX = 11000;
export const TEXT_ELEMENT_INIT_ZINDEX = 12000;
export const GAP_FOR_VIGENETTE = 15;
export const MIN_CANVAS_DPI = 300;
export const NAV_BTN_CONTAINER_HEIGHT = 70;
export const MAX_CLOUD_IMAGE_SIZE = 2000;
export const CANVAS_SNAP_THRESHOLD = 2;
export const CANVAS_OVER_VIGNETTE_MIN_WIDTH = 50;
export const disableCheckLowDpi = true;
export const RESOURCES_PATH = '/resources/assets';
export const SCENE7_URL_BASE = 'http://images.promotionalstore.com/is/image/PromotionalStore/i?fmt=png-alpha';
export const SCENE7_TEMPLATE_BASIC_URL_UPLOAD =
  'http://images.promotionalstore.com/is/image/PromotionalStore/i?allowCanvasPrompt=false&fmt=png-alpha';
export const SCENE7_TEMPLATE_BASIC_URL_BACKGROUND =
  'http://images.promotionalstore.com/is/image/PromotionalStore/i/TemplateBasic?layer=0&opac=0&fmt=png-alpha';
export const SCENE7_TEMPLATE_BASIC_URL_STATIC =
  'https://images.promotionalstore.com/is/image/PromotionalStore/i?src=is{PromotionalStore/{Scene7FileName}}&fmt=png-alpha';
export const SCENE7_TEMPLATE_BASIC_URL_FOR_SAVEDART =
  'https://images.promotionalstore.com/is/image/PromotionalStore/i?src=is{{Scene7FileName}}&fmt=png-alpha';
export const SCENE7_TEMPLATE_BASIC_URL_HOTSTAMPED = `https://images.promotionalstore.com/is/image/PromotionalStore/i?src=is({hotstampedSrc})&mask=is({maskSrc})&fmt=png-alpha`;

export const logoLayoutOption = {
  LogoAboveText: 0,
  LogoBelowText: 1,
  LogoLeftOfText: 2,
  LogoRightOfText: 3,
};

export const logoTextProcessType = {
  LogoOnly: 0,
  LogoOnlyCrop: 1,
  LogoOnlyRotate: 2,
  LogoOnlyCropRotate: 3,

  LogoAboveText: 4,
  LogoAboveTextRotate: 5,
  LogoAboveTextCrop: 6,
  LogoAboveTextCropRotate: 7,

  LogoBelowText: 8,
  LogoBelowTextRotate: 9,
  LogoBelowTextCrop: 10,
  LogoBelowTextCropRotate: 11,

  LogoLeftOfText: 12,
  LogoLeftOfTextRotate: 13,
  LogoLeftOfTextCrop: 14,
  LogoLeftOfTextCropRotate: 15,

  LogoRightOfText: 16,
  LogoRightOfTextRotate: 17,
  LogoRightOfTextCrop: 18,
  LogoRightOfTextCropRotate: 19,

  BackgroundCrop: 20,
  BackgroundRotate: 21,
  BackgroundCropRotate: 22,
};

export const DEFAULT_SUPERIMPOSED_VIGNETTE_SIZE = 600;
export const CANVAS_ZOOM_EXTRA_REDUCTION = isMobileOnly ? 10 : 3;
export const MOBILE_CANVAS_TAB_MARGIN = 123;

export const vignetteCanvasConfigType = {
  Inside: 0,
  LeftOut: 1,
  RightOut: 2,
  LeftRightOut: 3,
  TopOut: 4,
  BottomOut: 5,
  TopBottomOut: 6,
};

export const imageSharpenStatus = {
  NotAvailable: 0,
  Unsharpened: 1,
  Sharpened: 2,
};

export const stepStatus = {
  Done: 0,
  Active: 1,
  ToDo: 2,
};

export const pushToUndoListMode = {
  Normal: 0,
  AddNew: 1,
  UpdateTextElement: 2,
  None: 3,
};

export const undoRedoType = {
  Init: 0,
  ChangeTemplateOrEditElement: 1,
  UploadBackground: 2,
  UploadLogo: 3,
  SelectStockArt: 4,
  SelectSavedArt: 5,
  SelectSharedArt: 6,
  SlideRotateAngle: 7,
  SelectElement: 8,
};

export const canvasSnapLineMode = {
  Left: 1,
  Right: 2,
  Top: 3,
  Bottom: 4,
  CenterX: 5,
  CenterY: 6,
  NextLeft: 7,
  NextRight: 8,
  NextTop: 9,
  NextBottom: 10,
};

export const canvasResizingPhase = {
  OneRowAndNoResizing: 1,
  OneRowAndResizingCanvas: 2,
  TwoRowsAndNoResizing: 3,
  TwoRowsAndResizingSideBar: 4,
  TwoRowsAndResizingCanvas: 5,
  ThreeRows: 6,
};

export const canvasItemType = {
  Normal: 0,
  FoldCalender: 1,
  MugAndBottle: 3,
  WallCalendar: 5,
};

/**
 * EditPreview: only show EditColor Link in EditUserImage Component, can't change Logo/Text Color
 * EditStock/EditStock/EditSaved/EditPreview/EditVerse show EditUserImage in NonDigital Studio
 * blame EditUpload
 */
export const userImageStep = {
  Check: -1,
  Init: 0,
  Upload: 1,
  Stock: 2,
  Recent: 3,
  Saved: 4,
  EditUpload: 5,
  EditStock: 6,
  EditSaved: 7,
  LogoRemoveWhite: 8,
  Slogan: 9,
  EditSlogan: 10,
  EditPreview: 11,
  Verse: 12,
  EditVerse: 13,
  Sentiment: 14,
  EditSentiment: 15,
};

export const stockSteps = {
  Category: 0,
  List: 1,
  Search: 2,
  Preview: 999,
};

export const templateSteps = {
  Category: 0,
  List: 1,
  Search: 2,
  Preview: 999,
};

export const savedAndSharedSteps = {
  List: 0,
  Searching: 1,
  NoSearch: 2,
};

// the progress status for imaging service
export const serviceProgressStatus = {
  None: 0,
  Uploading: 1,
  Processing: 2,
  Downloading: 3,
  Complete: 4,
  Error: 5,
};

//text editing status of digital products for mobile only
export const textEditingStatus = {
  Init: 0,
  EditText: 1,
  ChangeFont: 2,
  ChangeFontSize: 3,
  EditColors: 4,
  EditTextStyle: 5,
  EditTextOutline: 6,
  EditTextRotate: 7,
  AddSymbols: 8,
};

export const sidebarTabKeyEnum = {
  Warning: -1,
  WhatsNext: 0,
  Background: 1,
  Logo: 2,
  Text: 3,
  OutsideSlogan: 4,
  Verse: 5,
  Sentiment: 6,
  Preview: 7,
  Print: 8,
  Email: 9,
  ViewPricing: 10,
};

export const removeWhiteMode = {
  None: 0,
  RemoveEdge: 1,
  RemoveAll: 2,
};

export const elementType = {
  Text: 0,
  Image: 1,
};
export const userImageEditButton = {
  Back: 0,
  CancelApply: 1,
};

export const userImageType = {
  NotSet: -1,
  UploadLogo: 0,
  StockArt: 1,
  Slogan: 2,
  RecentArt: 3,
  SharedArt: 4,
  SavedArt: 5,
  Static: 6,
  Verse: 7,
  Sentiment: 8,
};
export const elementStatus = {
  Unselected: 0,
  SingleSelected: 1,
  BatchSelected: 2,
  TempSelected: 3,
};

export const previewType = {
  Fxg: 0,
  Vignette: 1,
  StockImage: 2,
};

export const modalType = {
  None: 0, //not show
  Email: 1,
  Print: 2,
  SaveProject: 3,
  Preview: 4,
};

export const digitalTemplateType = {
  Common: 0,
  Custom: 1,
  Default: 2,
  Blank: 3,
};

export const cmykLabel = {
  C: 'C',
  M: 'M',
  Y: 'Y',
  K: 'K',
};

export const colors = [
  ['600528', '38 100 64 52', 'Crimson'],
  ['a30234', '0 100 60 37', 'Burgundy'],
  ['ff000d', '0 100 100 0', 'Red'],
  ['ce4652', '0 83 54 16', 'Rose'],
  ['f15d5e', '0 79 58 0', 'Coral'],
  ['f08b1d', '0 53 100 2', 'Orange'],
  ['fdb813', '0 30 100 0', 'Light Orange'],
  ['d0981b', '0 31 96 20', 'Golden Brown'],
  ['fbb161', '0 35 70 0', 'Peach'],
  ['ffea53', '0 4 79 0', 'Yellow'],
  ['fff797', '0 0 51 0', 'Light Yellow'],
  ['d4d10f', '10 0 100 11', 'Lime Green'],
  ['701471', '52 100 0 26', 'Purple'],
  ['ff0092', '0 96 0 0', 'Pink'],
  ['d708b2', '23 91 0 0', 'Magenta'],
  ['bf83b9', '24 56 0 0', 'Lavender'],
  ['e9cfe4', '6 20 0 0', 'Light Pink'],
  ['88d6f8', '42 0 0 0', 'Baby Blue'],
  ['40bde8', '63 4 2 0', 'Sky Blue'],
  ['00a9b9', '87 0 26 6', 'Teal'],
  ['00868e', '75 0 26 35', 'Aqua'],
  ['007cc2', '89 43 0 0', 'Blue'],
  ['1c2674', '100 94 0 29', 'Dark Blue'],
  ['111a49', '100 92 29 49', 'Navy Blue'],
  ['000000', '0 0 0 100', ' Black'],
  ['959484', '0 0 16 50', 'Gray'],
  ['e4e5e6', '0 0 0 11', 'Light Gray'],
  ['ffffff', '0 0 0 0', 'White'],
  ['ffebd6', '0 8 15 0', 'Tan'],
  ['c09c84', '25 38 48 1', 'Light Brown'],
  ['9e6614', '10 49 100 35', 'Brown'],
  ['74401a', '36 73 100 39', 'Dark Brown'],
  ['114432', '59 0 53 80', 'Forest Green'],
  ['00a651', '100 0 100 0', 'Green'],
  ['54b948', '69 0 100 0', 'Light Green'],
  ['b3d88c', '32 0 59 0', 'Pastel Green'],
];

export const pageUrl = {
  MyAccount: '/Default.aspx?FocusId=CustomerService/MyAccount.ascx',
  OrderTracking: '/Default.aspx?FocusId=CustomerService/OrderTracking.ascx',
  MySavedProject: '/Default.aspx?FocusId=Shopping/MySavedProject.ascx',
  MyWishList: '/Default.aspx?FocusId=Shopping/MyWishList.ascx',
  QuickReorder: '/Default.aspx?FocusId=Shopping/QuickReorder.ascx',
  MyInvoice: '/Default.aspx?FocusId=CustomerService/UnpaidInvoices.ascx',
  ShoppingCart: '/Default.aspx?FocusId=Shopping/ShoppingCart.ascx',
  WindmillArtworkGuideLines: '/Default.aspx?FocusId=windmillartworkguidelines.htm',
  Sample: '/Default.aspx?FocusId=Samples.ascx',
  ResourceCenter: '/Default.aspx?FocusId=resourcecenter.htm',
  MultilineReps: '/Default.aspx?FocusId=multilinereplisting.htm',
  CustomerService: '/Default.aspx?FocusId=customerservice.htm',
  ContactUs: '/Default.aspx?FocusId=contactus.htm',
  AboutUs: '/Default.aspx?FocusId=aboutus.htm',
  Favorites: '/Default.aspx?FocusId=Shopping/Favorites.ascx',
};

export const jumpLinkType = {
  None: -1,
  MyAccount: 0,
  OrderTracking: 1,
  MySavedProject: 2,
  MyWishList: 3,
  QuickReorder: 4,
  MyInvoice: 5,
  ShoppingCart: 6,
  WindmillArtworkGuideLines: 7,
  Sample: 8,
  ResourceCenter: 9,
  MultilineReps: 10,
  CustomerService: 11,
  ContactUs: 12,
  AboutUs: 13,
  Favorites: 14,
};
//element alignment
export const hMultiAlign = {
  Left: '0',
  Center: '1',
  Right: '2',
};
// canvas alignment
export const horizonAlign = {
  Left: '0',
  Center: '0.5',
  Right: '1',
};

export const verticalAlign = {
  Top: '0',
  Center: '0.5',
  Bottom: '1',
};

export const direction = {
  Horizontal: 'horizontal',
  vertical: 'vertical',
};

export const colorType = {
  NotSet: 100,
  Digital: 0,
  Traditional: 1,
  Pms: 2,
};

export const brand = {
  APL: 'APL',
  BWC: 'BWC',
  CAN: 'CAN',
  USD: 'USD',
  WIN: 'WIN',
  WMC: 'WMC',
  THY: 'THY',
  GOP: 'GOP',
};
export const textMode = {
  Single: 0,
  Multiple: 1,
};
export const CTSWebChat = {
  APL: {
    Chat: 'https://chat-amsterdamprinting.orders.com:443/js/chat.js',
    Icon: 'chat_white.svg',
    OfflineIcon: 'chat_gray_offline.svg',
    MobileIcon: 'chat_blue_text_blk.svg',
    MobileOfflineIcon: 'chat_gray_text_blk_offline.svg',
    OfflineBackgroundColor: '#036341',
    ChatOfflineFormLogo: 'https://static-resource.promotionalstore.com/resources/js/ContactPro/img/logo-apl.svg',
  },
  CAN: {
    Chat: 'https://chat-amsterdamproducts.orders.com:443/js/chat.js',
    Icon: 'chat_white.svg',
    OfflineIcon: 'chat_gray_offline.svg',
    MobileIcon: 'chat_blue_text_blk.svg',
    MobileOfflineIcon: 'chat_gray_text_blk_offline.svg',
    OfflineBackgroundColor: '#047C52',
    ChatOfflineFormLogo: 'https://static-resource.promotionalstore.com/resources/js/ContactPro/img/logo-can.svg',
  },
  BWC: {
    Chat: 'https://chat-baldwincooke.orders.com:443/js/chat.js',
    Icon: 'chat_white.svg',
    OfflineIcon: 'chat_gray_offline.svg',
    OfflineBackgroundColor: '#0076bb',
    ChatOfflineFormLogo: 'https://static-resource.promotionalstore.com/resources/js/ContactPro/img/logo-bwc.svg',
  },
  USD: {
    Chat: 'https://chat-usdiary.orders.com:443/js/chat.js',
    Icon: 'chat_white.svg',
    OfflineIcon: 'chat_gray_offline.svg',
    OfflineBackgroundColor: '#9d2d26',
    ChatOfflineFormLogo: 'https://static-resource.promotionalstore.com/resources/js/ContactPro/img/logo-usd.svg',
  },
  WIN: {
    Chat: 'https://chat-adgpromo.orders.com:443/js/chat.js',
    Icon: 'chat_pink_blue.svg',
    OfflineIcon: 'chat_pink_offline.svg',
    MobileIcon: 'chat_blue_blk_square.svg',
    MobileOfflineIcon: 'chat_gray_blk_square_offline.svg',
    OfflineBackgroundColor: '#33C5F3',
    ChatOfflineFormLogo: 'https://static-resource.promotionalstore.com/resources/js/ContactPro/img/logo-adg.svg',
  },
  THY: {
    Chat: 'https://chat-cordialgreetings.orders.com:443/js/chat.js',
    Icon: 'chat_blue.svg',
    OfflineIcon: 'chat_gray_offline.svg',
    MobileIcon: 'chat_blue_blk_square.svg',
    MobileOfflineIcon: 'chat_gray_blk_square_offline.svg',
    OfflineBackgroundColor: '#394a9b',
    ChatOfflineFormLogo: 'https://static-resource.promotionalstore.com/resources/js/ContactPro/img/logo-cor.svg',
  },
  GOP: {
    Chat: 'https://chat-123promos.orders.com:443/js/chat.js',
    Icon: 'chat_blk.svg',
    OfflineIcon: 'chat_blk_offline.svg',
    MobileIcon: 'chat_blk.svg',
    MobileOfflineIcon: 'chat_blk_offline.svg',
    OfflineBackgroundColor: 'rgb(52, 166, 71)',
    ChatOfflineFormLogo: 'https://chat-123promos.orders.com/images/ct-suit-logo.png',
  },
};

export const stagingCTSWebChat = {
  APL: {
    Chat: 'https://chat-amsterdamprinting.apl.inet2:443/js/chat.js',
    Icon: 'chat_white.svg',
    OfflineIcon: 'chat_gray_offline.svg',
    MobileIcon: 'chat_blue_text_blk.svg',
    MobileOfflineIcon: 'chat_gray_text_blk_offline.svg',
    OfflineBackgroundColor: '#036341',
    ChatOfflineFormLogo: 'https://static-resource.promotionalstore.com/resources/js/ContactPro/img/logo-apl.svg',
  },
  CAN: {
    Chat: 'https://chat-amsterdamproducts.apl.inet2:443/js/chat.js',
    Icon: 'chat_white.svg',
    OfflineIcon: 'chat_gray_offline.svg',
    MobileIcon: 'chat_blue_text_blk.svg',
    MobileOfflineIcon: 'chat_gray_text_blk_offline.svg',
    OfflineBackgroundColor: '#047C52',
    ChatOfflineFormLogo: 'https://static-resource.promotionalstore.com/resources/js/ContactPro/img/logo-can.svg',
  },
  BWC: {
    Chat: 'https://chat-baldwincooke.apl.inet2:443/js/chat.js',
    Icon: 'chat_white.svg',
    OfflineIcon: 'chat_gray_offline.svg',
    OfflineBackgroundColor: '#0076bb',
    ChatOfflineFormLogo: 'https://static-resource.promotionalstore.com/resources/js/ContactPro/img/logo-bwc.svg',
  },
  USD: {
    Chat: 'https://chat-usdiary.apl.inet2:443/js/chat.js',
    Icon: 'chat_white.svg',
    OfflineIcon: 'chat_gray_offline.svg',
    OfflineBackgroundColor: '#9d2d26',
    ChatOfflineFormLogo: 'https://static-resource.promotionalstore.com/resources/js/ContactPro/img/logo-usd.svg',
  },
  WIN: {
    Chat: 'https://chat-adgpromo.apl.inet2:443/js/chat.js',
    Icon: 'chat_pink_blue.svg',
    OfflineIcon: 'chat_pink_offline.svg',
    MobileIcon: 'chat_blue_blk_square.svg',
    MobileOfflineIcon: 'chat_gray_blk_square_offline.svg',
    OfflineBackgroundColor: '#33C5F3',
    ChatOfflineFormLogo: 'https://static-resource.promotionalstore.com/resources/js/ContactPro/img/logo-adg.svg',
  },
  THY: {
    Chat: 'https://chat-cordialgreetings.apl.inet2:443/js/chat.js',
    Icon: 'chat_blue.svg',
    OfflineIcon: 'chat_gray_offline.svg',
    MobileIcon: 'chat_blue_blk_square.svg',
    MobileOfflineIcon: 'chat_gray_blk_square_offline.svg',
    OfflineBackgroundColor: '#394a9b',
    ChatOfflineFormLogo: 'https://static-resource.promotionalstore.com/resources/js/ContactPro/img/logo-cor.svg',
  },
  GOP: {
    Chat: 'https://chat-123promos.apl.inet2:443/js/chat.js',
    Icon: 'chat_blk.svg',
    OfflineIcon: 'chat_blk_offline.svg',
    MobileIcon: 'chat_blk.svg',
    MobileOfflineIcon: 'chat_blk_offline.svg',
    OfflineBackgroundColor: 'rgb(52, 166, 71)',
    ChatOfflineFormLogo: 'https://chat-123promos.orders.com/images/ct-suit-logo.png',
  },
};

export const backgroundEditStep = {
  RemoveWhite: 0,
  Rotate: 1,
  Crop: 2,
};

export const logoEditingStatusEnum = {
  None: 0,

  //Digital status
  LogoCropping: 11,
  BackgroundRemoveWhite: 12,
  BackgroundRotate: 13,
  BackgroundCrop: 14,
  DigitalLogoColorPicker: 15,
  DigitalLogoRemoveWhite: 16,
  DpiWarningPanel: 17,
  DpiWarningButton: 18,
  DpiWarningContinueToCart: 19,

  //Non-Digital status
  NonDigitalLogoRemoveWhite: 31,
  NonDigitalLogoCrop: 32,
  NonDigitalLogoRotate: 33,
  NonDigitalLogoColor: 34,
  NonDigitalLogoColorPicker: 35,
  NonDigitalLogoPreview: 36,
  NonDigitalLogoAsRecent: 37,

  //ScreenPrintedDigital status
  ScreenPrintedLogoColorPicker: 51,
  ScreenPrintedEditUpload: 52,
};

export const bomOptionType = {
  Single: 0,
  Multiple: 1,
};
export const responseType = {
  Success: 0,
  Error: 1,
  Invalid: 2,
  TooManyRequests: 3,
  IncludeInvalidUrl: 4,
};

export const calendarSideType = {
  LeftSide: 1, // on back
  RightSide: 0,
};
export const defaultImageColor = {
  rgb: '000000',
  cmyk: '0 0 0 100',
};

export const logoSource = {
  New: 0,
  Recent: 1,
  Edit: 2,
  Reorder: 3,
};

export const textStyleType = {
  Bold: 'bold',
  Italic: 'italic',
  Underline: 'underline',
};

export const vendorId = {
  Amsterdam: 100010,
  AmsterdamProducts: 100020,
  BaldwinCooke: 100030,
  USDiary: 100050,
  Windmill: 100060,
  WindmillCanada: 100070,
  CordialGreetings: 100080,
  TaylorCommunications: 31,
  CGI: 1,
  SuperiorEnergy: 28,
  TC_Demo_Site: 23,
  Promos: 106,
};

export const vendorDict = {
  100010: {
    csNumber: '1.800.833.6231',
    rootDir: '/Customer/Amsterdam/',
    site: 'APLAPL',
    companyName: 'Amsterdam Printing & Litho',
    favicon: 'favicon.ico?v=2',
  },
  100020: {
    csNumber: '1.800.267.9200',
    rootDir: '/Customer/AmsterdamProducts/',
    site: 'CANCAN',
    companyName: 'Amsterdam Products',
    favicon: 'favicon.ico?v=2',
  },
  100030: {
    csNumber: '1.800.762.5000',
    rootDir: '/Customer/BaldwinCooke/',
    site: 'BWCBWC',
    companyName: 'Baldwin Cooke',
    favicon: 'favicon.ico',
  },
  100050: {
    csNumber: '1.800.345.3545',
    rootDir: '/Customer/USDiary/',
    site: 'USDUSD',
    companyName: 'U.S. Diary',
    favicon: 'favicon.ico',
  },
  100060: {
    rootDir: '/Customer/Windmill/',
    site: 'WINWIN',
    companyName: 'Adg Promo',
    favicon: 'favicon.ico',
  },
  100070: {
    rootDir: '/Customer/WindmillCanada/',
    site: 'CANWMC',
    companyName: 'Windmill Canada',
    favicon: 'favicon.ico',
  },
  100080: {
    rootDir: '/Customer/CordialGreetings/',
    site: 'THYCOR',
    companyName: 'Cordial Greetings',
    favicon: 'favicon.png',
  },
  31: {
    csNumber: '1.800.833.6231',
    rootDir: '/Customer/TaylorCommunications/',
    site: 'TPPTPM',
    companyName: 'Taylor Promo Marketing',
    favicon: 'favicon.png',
  },
  23: {
    csNumber: '1.800.833.6231',
    rootDir: '/Customer/TaylorCommunications/',
    site: 'TPPTPM',
    companyName: 'Taylor Promo Marketing',
  },
  52: {
    rootDir: '/Customer/OfficeDepot/',
    site: 'SSPODP',
    companyName: 'Office Depot',
  },
  106: {
    rootDir: '/Customer/123Promos/',
    site: 'GOPGOP',
    companyName: '123Promos',
    favicon: 'favicon.ico',
  },
};
export const hostVendorDict = {
  LOCAL: {
    csNumber: '1.800.833.6231',
    rootDir: '/Customer/Amsterdam/',
    companyName: 'Amsterdam Printing & Litho',
  },
  AMSTERDAM: {
    csNumber: '1.800.833.6231',
    rootDir: '/Customer/Amsterdam/',
    companyName: 'Amsterdam',
  },
  AMSTERDAMPRODUCTS: {
    csNumber: '1.800.267.9200',
    rootDir: '/Customer/AmsterdamProducts/',
    companyName: 'Amsterdam Products',
  },
  BALDWINCOOKE: {
    csNumber: '1.800.762.5000',
    rootDir: '/Customer/BaldwinCooke/',
    companyName: 'Baldwin Cooke',
  },
  USDIARY: {
    csNumber: '1.800.345.3545',
    rootDir: '/Customer/USDiary/',
    companyName: 'U.S. Diary',
  },
  WINDMILL: {
    rootDir: '/Customer/Windmill/',
    companyName: 'Adg Promo',
  },
  WINDMILLCANADA: {
    rootDir: '/Customer/WindmillCanada/',
    companyName: 'Windmill Canada',
  },
  TAYLORCOMMUNICATIONS: {
    csNumber: '1.800.833.6231',
    rootDir: '/Customer/TaylorCommunications/',
    companyName: 'Taylor Promo Marketing',
  },
  CORDIALGREETINGS: {
    csNumber: '1.800.257.8276',
    rootDir: '/Customer/CordialGreetings/',
    companyName: 'Cordial Greetings',
  },
};

export const imprintOptionType = {
  NA: 0,
  TextOnly: 1,
  LogoOnly: 2,
  TextLogo: 3,
  NoImprint: 4,
};

export const imprintOptionText = {
  TextOnly: 'text',
  LogoOnly: 'logo/art',
  TextLogo: 'logo/art and text',
  Slogan: 'slogan',
};
export const ProcessTypes = {
  ScreenPrinted: 1,
  HotStamped: 2,
  LaserEngraved: 3,
  Embroidered: 4,
  Deboss: 5,
  VendorDigital: 6,
  DigitalCeramicMug: 7,
  DigitalWaterBottle14: 8,
  DigitalTumbler: 10,
  DigitalMixingGlass: 11,
  DigitalPen: 12,
  DigitalWaterBottle17: 13,
  DigitalPens: 14,
  DigitalPocCal: 15,
  DigitalPocCalHor: 16,
  Digital7x10Cal: 17,
  DigitalMagnets: 18,
  DigitalBudPro: 19,
  DigitalBudWall: 20,
  DigitalDigitalWall: 21,
  DigitalFlipCalendars: 22,
  DigitalNotepad: 23,
  DigitalAtm: 24,
  DigitalApparel: 25,
  DigitalMimaki: 26,
  EnhancedImprintsLaser: 27,
  MultiImprtLaserPenBarrl: 28,
  MultiImprtLaserPenCap: 29,
  LaserVendor: 30,
  DrinkWareRimLine: 31,
  OneClrInkJet: 33,
  FoilFusing: 34,
  FullColorScreened: 35,
  IlluminatedLaser: 36,
  ColoredIlluminatedLaser: 37,
  DigitalIlluminatedLaser: 38,
  FullColorInkjetSoftex: 50,
  DigitalInkCups: 52,
  InkJetJournals: 53,
  InactiveImprintAreaCode: 999,
};

export const stockArtColorType = {
  Single: 0,
  Process: 1,
  Full: 2,
};
export const colorizationFlagEnum = {
  Normal: 0,
  NotMatch: 1,
  MoreThanAllowed: 2,
  NotMatchAndMoreThanAllowed: 3,
};
export const colorPickerType = {
  Text: 0,
  Logo: 1,
};
export const colorSpace = {
  NotSet: 0,
  SingleColor: 1,
  MultipleColor: 2,
};

const bsPrefix = 'configurator-web-';

const applyPrefix = (prefix, keys) => {
  return keys.reduce((acc, key) => {
    acc[key] = `${prefix}${key}`;
    return acc;
  }, {});
};

export const bootstrapCustomization = applyPrefix(bsPrefix, [
  'showing',
  'small',
  'mx',
  'pe',
  'end',
  'invisible',
  'form',
  'ms',
  'mark',
  'visible',
  'tooltip',
  'vr',
  'py',
  'card',
  'me',
  'bottom',
  'blockquote',
  'lead',
  'badge',
  'rounded',
  'align',
  'focus',
  'col',
  'bi',
  'm',
  'collapsing',
  'display',
  'dropdown',
  'sticky',
  'placeholder',
  'invalid',
  'column',
  'row',
  'z',
  'icon',
  'opacity',
  'gx',
  'gy',
  'overflow',
  'vw',
  'accordion',
  'mh',
  'h4',
  'breadcrumb',
  'h2',
  'hstack',
  'is',
  'my',
  'spinner',
  'h5',
  'float',
  'h6',
  'disabled',
  'order',
  'popover',
  'carousel',
  'border',
  'valid',
  'img',
  'h',
  'w',
  'navbar',
  'h1',
  'min',
  'lh',
  'input',
  'list',
  'caption',
  'flex',
  'ratio',
  'mb',
  'px',
  'pb',
  'justify',
  'fs',
  'fst',
  'initialism',
  'h3',
  'p',
  'fade',
  'figure',
  'mt',
  'show',
  'btn',
  'tab',
  'user',
  'offset',
  'modal',
  'pagination',
  'translate',
  'fw',
  'page',
  'nav',
  'progress',
  'ps',
  'gap',
  'position',
  'pt',
  'offcanvas',
  'container',
  'object',
  'vstack',
  'bg',
  'toast',
  'active',
  'start',
  'd',
  'mw',
  'fixed',
  'text',
  'link',
  'pointer',
  'vh',
  'top',
  'collapse',
  'shadow',
  'alert',
  'font',
  'table',
  'collapsed',
]);

export const bootstrapCustomizationForUpsells = {
  btn: `${bsPrefix}btn`,
  pagination: `${bsPrefix}pagination`,
  dropdown: `${bsPrefix}dropdown`,
  'dropdown-menu': `${bsPrefix}dropdown-menu`,
  'dropdown-item': `${bsPrefix}dropdown-item`,
  'dropdown-toggle': `${bsPrefix}dropdown-toggle`,
  'modal-open': `${bsPrefix}modal-open`,
  modal: `${bsPrefix}modal`,
  'modal-dialog': `${bsPrefix}modal-dialog`,
  'modal-content': `${bsPrefix}modal-content`,
  'modal-backdrop': `${bsPrefix}modal-backdrop`,
  'modal-header': `${bsPrefix}modal-header`,
  'modal-body': `${bsPrefix}modal-body`,
  'modal-footer': `${bsPrefix}modal-footer`,
  form: `${bsPrefix}form`,
  'form-control': `${bsPrefix}form-control`,
};
export const fixedContainerType = {
  top: 0,
  bottom: 1,
};

export const processButtonType = {
  none: -1,
  cancel: 0,
  back: 1,
  next: 2,
  continue: 3,
  apply: 4,
  applyToAll: 5,
  applyBackground: 6,
  noThanks: 7,
  addToCart: 8,
  personalizeAndAddToCart: 9,
  returnToAdmin: 10,
  emailPreview: 11,
  send: 12,
  printPreview: 13,
  print: 14,
  save: 15,
  ok: 16,
  noWantAddText: 17,
  wantAddText: 18,
  previous: 19,
  noWantAddImprintText: 20,
  wantAddImprintText: 21,
  noWantAddImprintLogo: 22,
  wantAddImprintLogo: 23,
  noWantAddImprintTextLogo: 24,
  wantAddImprintTextLogo: 25,
  noWantAddImprintSlogan: 26,
  wantAddImprintSlogan: 27,
  emailVirtualProof: 28,
};

const arrowleftblue = '/resources/assets/ui/mobile/arrowleftblue.svg';
export const arrowrightwhite = '/resources/assets/ui/mobile/arrowrightwhite.svg';
export const arrowrightblack = '/resources/assets/ui/mobile/arrowrightblack.svg';
const xblue = '/resources/assets/ui/mobile/xblue.svg';
const checkwhite = '/resources/assets/ui/mobile/checkwhite.svg';
const checkblack = '/resources/assets/ui/mobile/checkblack.svg';
const applytoall = '/resources/assets/ui/mobile/applytoall.svg';
const applytoallblack = '/resources/assets/ui/mobile/applytoallblack.svg';
export const cart = '/resources/assets/ui/mobile/addtocart.svg';
export const cartblack = '/resources/assets/ui/mobile/addtocartblack.svg';
const emailpreview = '/resources/assets/ui/mobile/emailpreview.svg';
const printpreview = '/resources/assets/ui/mobile/printpreview.svg';
const addtext = '/resources/assets/ui/desktop/add_text_studio.svg';

// ['text', icon]
export const processButtonDict = {
  [processButtonType.cancel]: ['Cancel', xblue],
  [processButtonType.back]: ['Back', arrowleftblue],
  [processButtonType.next]: ['Next', arrowrightwhite],
  [processButtonType.continue]: ['Continue', arrowrightwhite],
  [processButtonType.apply]: ['Apply', checkwhite],
  [processButtonType.applyToAll]: ['Apply to All', applytoall],
  [processButtonType.applyBackground]: ['Apply Background', arrowrightwhite],
  [processButtonType.noThanks]: ['No Thanks', xblue],
  [processButtonType.addToCart]: ['Add to Cart', cart],
  [processButtonType.personalizeAndAddToCart]: ['Personalize & Add to Cart', arrowrightwhite],
  [processButtonType.returnToAdmin]: ['Save & Return to Admin', arrowrightwhite],
  [processButtonType.emailPreview]: ['Email Preview', emailpreview],
  [processButtonType.send]: ['Send', arrowrightwhite],
  [processButtonType.printPreview]: ['Print Preview', printpreview],
  [processButtonType.print]: ['Print', arrowrightwhite],
  [processButtonType.save]: ['Save', arrowrightwhite],
  [processButtonType.ok]: ['OK', arrowrightwhite],
  [processButtonType.noWantAddText]: ["I don't want to add text", xblue],
  [processButtonType.wantAddText]: ['I want to add text', addtext],
  [processButtonType.previous]: ['Previous'],
  [processButtonType.noWantAddImprintText]: ["I don't want to add text", xblue],
  [processButtonType.wantAddImprintText]: ['I want to add text', arrowrightwhite],
  [processButtonType.noWantAddImprintLogo]: ["I don't want to add logo/art", xblue],
  [processButtonType.wantAddImprintLogo]: ['I want to add logo/art', arrowrightwhite],
  [processButtonType.noWantAddImprintTextLogo]: ["I don't want to add logo/art and text", xblue],
  [processButtonType.wantAddImprintTextLogo]: ['I want to add logo/art and text', arrowrightwhite],
  [processButtonType.noWantAddImprintSlogan]: ["I don't want to add slogan", xblue],
  [processButtonType.wantAddImprintSlogan]: ['I want to add slogan', arrowrightwhite],
  [processButtonType.emailVirtualProof]: ['Email Virtual Proof', emailpreview],
};

export const processButtonDictForAplAndCan = {
  [processButtonType.cancel]: ['Cancel', xblue],
  [processButtonType.back]: ['Back', arrowleftblue],
  [processButtonType.next]: ['Next', arrowrightblack],
  [processButtonType.continue]: ['Continue', arrowrightblack],
  [processButtonType.apply]: ['Apply', checkblack],
  [processButtonType.applyToAll]: ['Apply to All', applytoallblack],
  [processButtonType.applyBackground]: ['Apply Background', arrowrightblack],
  [processButtonType.noThanks]: ['No Thanks', xblue],
  [processButtonType.addToCart]: ['Add to Cart', cartblack],
  [processButtonType.personalizeAndAddToCart]: ['Personalize & Add to Cart', arrowrightblack],
  [processButtonType.returnToAdmin]: ['Save & Return to Admin', arrowrightblack],
  [processButtonType.emailPreview]: ['Email Preview', emailpreview],
  [processButtonType.send]: ['Send', arrowrightblack],
  [processButtonType.printPreview]: ['Print Preview', printpreview],
  [processButtonType.print]: ['Print', arrowrightblack],
  [processButtonType.save]: ['Save', arrowrightblack],
  [processButtonType.ok]: ['OK', arrowrightblack],
  [processButtonType.noWantAddText]: ["I don't want to add text", xblue],
  [processButtonType.wantAddText]: ['I want to add text', addtext],
  [processButtonType.previous]: ['Previous'],
  [processButtonType.noWantAddImprintText]: ["I don't want to add text", xblue],
  [processButtonType.wantAddImprintText]: ['I want to add text', arrowrightblack],
  [processButtonType.noWantAddImprintLogo]: ["I don't want to add logo/art", xblue],
  [processButtonType.wantAddImprintLogo]: ['I want to add logo/art', arrowrightblack],
  [processButtonType.noWantAddImprintTextLogo]: ["I don't want to add logo/art and text", xblue],
  [processButtonType.wantAddImprintTextLogo]: ['I want to add logo/art and text', arrowrightblack],
  [processButtonType.noWantAddImprintSlogan]: ["I don't want to add slogan", xblue],
  [processButtonType.wantAddImprintSlogan]: ['I want to add slogan', arrowrightblack],
  [processButtonType.emailVirtualProof]: ['Email Virtual Proof', emailpreview],
};

export const nextBtnEvent = {
  next: 'persNext',
  productOptionsNext: 'productOptionsNext',
  imprintOptionsNext: 'imprintOptionsNext',
  addToCart: 'persAddtoCart',
  designServiceAddToCart: 'designServicesAddtoCart',
  productOptionsAddtoCart: 'productOptionsAddtoCart',
  noImprintAddtoCart: 'noImprintAddtoCart',
  upsellPopup: 'upsellPopup',
  upsellAddtoCart: 'upsellAddtoCart',
  upsellAddtoCartwithItem: 'upsellAddtoCartwithItem',
  upsellNoThanksAddtoCart: 'upsellNoThanksAddtoCart',
};

export const nextBtnId = {
  next: 'Studio_Personalization_Next_Btn',
  productOptionsNext: 'Studio_ProductOptions_Next_Btn',
  imprintOptionsNext: 'Studio_ImprintOptions_Next_Btn',
  addToCart: 'Studio_Personalization_AddtoCart_Btn',
  designServiceAddToCart: 'Studio_DesignService_AddtoCart_Btn',
  productOptionsAddtoCart: 'Studio_ProductOptions_AddtoCart_Btn',
  noImprintAddtoCart: 'Studio_NoImprint_AddtoCart_Btn',
  upsellAddtoCart: 'Studio_Upsell_AddtoCart_Btn',
  upsellNoThanksAddtoCart: 'Studio_NoThanks_AddtoCart_Btn',
  emailVirtualProof: 'Studio_Email-VirtualProof_Btn',
};

export const bomBackgroundColor = {
  auto: 0,
  mandatory: 1,
  mandatoryNot: 2,
};

export const disableLiveChatVendorId = [100070, 31];
export const disableTalkPhoneVendorId = [100070];

export const VwoCodeDict = {
  100010: {
    staging: '463242',
    production: '453442',
  },
  100020: {
    staging: '548324',
    production: '548324',
  },
  100030: {
    staging: '548327',
    production: '548327',
  },
  100050: {
    staging: '548330',
    production: '548330',
  },
  100060: {
    staging: '548333',
    production: '548333',
  },
  100070: {
    staging: '465405',
    production: '465405',
  },
  100080: {
    staging: '548339',
    production: '548339',
  },
  106: {
    staging: '548342',
    production: '548342',
  },
};

export const VwoCodeMobileDict = {
  100010: {
    staging: '',
    production: '465135',
  },
  100060: {
    staging: '548345',
    production: '548345',
  },
};

const backendApiPort = parseInt(process.env.REACT_APP_LOCAL_PORT, 10) === 3001 ? '5001' : '5078';

export const admintoolHostName = {
  development: `https://localhost:7038`,
  usadevelopment: `https://localhost:7038`,
  nlserver: `https://nltc339:9003`,
  staging: 'https://admintooltest.apl.inet2',
  production: 'https://admin.taylorpromo.inet',
};

export const NavinkApiHostBase = {
  development: `https://localhost:${backendApiPort}`,
  usadevelopment: `https://localhost:${backendApiPort}`,
  nlserver: 'https://aplpromostudio.nltechuat.com',
  staging: 'https://promoconfiguratorqa.navitor.com',
  production: 'https://promoconfigurator.orders.com',
};

export const websiteHostName = {
  100060: {
    development: `https://www.adgpromo.inet2`,
    usadevelopment: `https://www.adgpromo.inet2`,
    nlserver: `https://www.adgpromo.inet2`,
    staging: 'https://www.adgpromo.inet2',
    production: 'https://www.adgpromo.com',
  },
  100070: {
    development: `https://adgpromoca.apl.inet2`,
    usadevelopment: `https://adgpromoca.apl.inet2`,
    nlserver: `https://adgpromoca.apl.inet2`,
    staging: 'https://adgpromoca.apl.inet2',
    production: 'https://www.adgpromo.ca',
  },
};

export const vendorHostNameDictForApi = {
  100010: {
    development: `https://localhost:${backendApiPort}`,
    usadevelopment: `https://localhost:${backendApiPort}`,
    nlserver: 'https://aplpromostudio.nltechuat.com',
    staging: 'https://promostudio.amsterdamprinting.inet2',
    production: 'https://promostudio.amsterdamprinting.com',
  },
  100020: {
    development: `https://localhost:${backendApiPort}`,
    usadevelopment: `https://localhost:${backendApiPort}`,
    nlserver: 'https://aplpromostudio.nltechuat.com',
    staging: 'https://promostudioamsterdamproducts.apl.inet2',
    production: 'https://promostudio.amsterdamproducts.ca',
  },
  100030: {
    development: `https://localhost:${backendApiPort}`,
    usadevelopment: `https://localhost:${backendApiPort}`,
    nlserver: 'https://aplpromostudio.nltechuat.com',
    staging: 'https://promostudiobaldwincooke.apl.inet2',
    production: 'https://promostudio.baldwincooke.com',
  },
  100050: {
    development: `https://localhost:${backendApiPort}`,
    usadevelopment: `https://localhost:${backendApiPort}`,
    nlserver: 'https://aplpromostudio.nltechuat.com',
    staging: 'https://promostudiousdiary.apl.inet2',
    production: 'https://promostudio.usdiary.com',
  },
  100060: {
    development: `https://localhost:${backendApiPort}`,
    usadevelopment: `https://localhost:${backendApiPort}`,
    nlserver: 'https://aplpromostudio.nltechuat.com',
    staging: 'https://promostudioadgpromo.apl.inet2',
    production: 'https://promostudio.adgpromo.com',
  },
  100070: {
    development: `https://localhost:${backendApiPort}`,
    usadevelopment: `https://localhost:${backendApiPort}`,
    nlserver: 'https://aplpromostudio.nltechuat.com',
    staging: 'https://promostudioadgpromoca.apl.inet2',
    production: 'https://promostudio.adgpromo.ca',
  },
  100080: {
    development: `https://localhost:${backendApiPort}`,
    usadevelopment: `https://localhost:${backendApiPort}`,
    nlserver: 'https://aplpromostudio.nltechuat.com',
    staging: 'https://promostudiocordialgreetings.apl.inet2',
    production: 'https://promostudio.cordialgreetings.com',
  },
  106: {
    development: `https://localhost:${backendApiPort}`,
    usadevelopment: `https://localhost:${backendApiPort}`,
    nlserver: 'https://aplpromostudio.nltechuat.com',
    staging: 'https://coreconfigurator123promos.apl.inet2',
    production: 'https://promostudio.123promos.com',
  },
  31: {
    development: `https://localhost:${backendApiPort}`,
    usadevelopment: `https://localhost:${backendApiPort}`,
    nlserver: 'https://aplpromostudio.nltechuat.com',
    staging: 'https://promostudiotaylorpromo.apl.inet2',
    production: 'https://promostudio.taylorpromo.com',
  },
  23: {
    development: `https://localhost:${backendApiPort}`,
    usadevelopment: `https://localhost:${backendApiPort}`,
    nlserver: 'https://aplpromostudio.nltechuat.com',
    staging: 'https://promostudiotaylorpromo.apl.inet2',
    production: 'https://promostudio.taylorcommunications.com',
  },
  52: {
    development: `https://localhost:${backendApiPort}`,
    usadevelopment: `https://localhost:${backendApiPort}`,
    nlserver: 'https://aplpromostudio.nltechuat.com',
    staging: 'https://promoconfiguratorqa.navitor.com',
    production: 'https://promoconfigurator.orders.com',
  },
};

export const rotateDirectionEnum = {
  degrees0: 0,
  degrees90: 90,
  degrees180: 180,
  degrees270: 270,
};

export const domNodeId = {
  canvasArea: 'canvas-area',
  imprintViewContainer: 'imprint-view-container',
  canvasContainer: 'canvas-container',
  canvasVignette: 'canva-vignette',
  step2Container: 'step2-container',
  step2ContainerLeftSide: 'step2-container-leftside',
  step2ContainerRightSide: 'step2-container-rightside',
  step2ContainerBottomSide: 'step2-container-Bottom',
  step2EditPanel: 'step2-edit-panel',
  step2ImprintPanel: 'step2-imprint-panel',
  previewPanel: 'preview-panel',
  horizontalLayout: 'horizontal-layout',
  sideBarEditOption: 'sidebar-edit-option',
  canvasTopToolbar: 'canvas-top-toolbar',
  imageContainer: 'image-container',
  imprintImage: 'imprint-image',
  appConfigurator: 'app-configurator',
  previewDisclaimer: 'preview-disclaimer',
  previewDisclaimerQuestionMark: 'preview-disclaimer-question-mark',
  previewDisclaimerTextLine1: 'preview-disclaimer-text-line1',
  previewDisclaimerTextLine2: 'preview-disclaimer-text-line2',
  previewDisclaimerSeparatorText: 'preview-disclaimer-separator-text',
  canvasNode: 'CANVAS',
  canvasOverVignette: 'canvas-over-vignette',
  canvasImgOverVignette: 'canvas-img-over-vignette',
  sideBarOptionContent: 'sidebar-option-content',
  offlineChatBox: 'divChatBox2',
};

export const rulerDirection = {
  vertical: 0,
  horizontal: 1,
};

export const scene7StockImageMode = {
  Ignored: -1,
  NotExist: 0,
  ItemExist: 1,
  TwinItemExist: 2,
};

export const mobileHeaderIcon = {
  100010: {
    CallusIcon: 'call_blue_text_blk.svg',
    MyAccountIcon: 'account_blue_text_blue.svg',
    MyAccountActiveIcon: 'account_white.svg',
    ActiveCartIcon: 'cart_blue_text_blk.svg',
  },
  100020: {
    CallusIcon: 'call_blue_text_blk.svg',
    MyAccountIcon: 'account_blue_text_blue.svg',
    MyAccountActiveIcon: 'account_white.svg',
    ActiveCartIcon: 'cart_blue_text_blk.svg',
  },
  100030: {
    CallusIcon: 'call_white_bg_blue_square.svg',
    MyAccountIcon: 'account_white_bg_blue_square.svg',
    ActiveCartIcon: 'cart_white_bg_blue_square.svg',
  },
  100050: {
    CallusIcon: 'call_white_bg_blue_square.svg',
    MyAccountIcon: 'account_white_bg_blue_square.svg',
    ActiveCartIcon: 'cart_white_bg_blue_square.svg',
  },
  100060: {
    CallusIcon: 'call_white_bg_blue_square.svg',
    MyAccountIcon: 'account_white_bg_blue_square.svg',
    ActiveCartIcon: 'cart_white_bg_blue_square.svg',
  },
  100070: {
    MyAccountIcon: 'account_white_bg_blue_square.svg',
    ActiveCartIcon: 'cart_white_bg_blue_square.svg',
  },
  100080: {
    CallusIcon: 'call_white_bg_blue_square.svg',
    MyAccountIcon: 'account_white_bg_blue_square.svg',
    ActiveCartIcon: 'cart_white_bg_blue_square.svg',
  },
  106: {
    MyAccountIcon: 'account_white_border_blk.svg',
    ActiveCartIcon: 'cart_white_border_blk.svg',
    MyAccountActiveIcon: 'account_x_blk.svg',
  },
};

export const nucleusHostName = {
  development: `https://demo.silcn.co`,
  usadevelopment: `https://demo.silcn.co`,
  nlserver: `https://demo.silcn.co`,
  staging: 'https://demo.silcn.co',
  production: 'https://prod.silcn.co',
};

export const bootstrapCustomizationForPreviewWindow = {
  modal: `${bsPrefix}modal`,
  'modal-backdrop': `${bsPrefix}modal-backdrop`,
};
